import type { WebMapStyleDto } from 'cadenza/map/layer-configuration-panel/webmapstyle-configuration/webmapstyle-configuration';
import type { SelectOption } from 'ui/select/select';

/**
 * Adapts the dto such that it can be used in both Select- and SelectList-components.
 *
 * @param availableStyles
 * @param selectedStyleId
 * @return Select options
 */
export function adaptAvailableStyles (availableStyles: WebMapStyleDto[], selectedStyleId: string): (WebMapStyleDto & SelectOption)[] {
  return availableStyles.map(style => ({
    ...style, // already contains `id` for Select
    value: style.id, // SelectList
    text: style.name, // Select
    label: style.name, // SelectList
    selected: style.id === selectedStyleId // Select and SelectList
  }));
}
